import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DebitNoteModel } from '@app/core/Models';
import { environment } from '@environments/environment';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { CommonService } from '../..';

@Injectable({
  providedIn: 'root',
})
export class DebitNoteService {
  constructor(private http: HttpClient, private commonService: CommonService) {}

  createDebitNote(debitNote: DebitNoteModel): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(
      `${environment.apiVersionUrl}DebitNote/save`,
      this.commonService.trimObjectSpace(JSON.stringify(debitNote)),
      headers
    );
  }

  getDataByDebitNoteId(debitNoteId: Guid): Observable<DebitNoteModel> {
    return this.http.get<DebitNoteModel>(
      `${environment.apiVersionUrl}DebitNote/get/${debitNoteId}`
    );
  }

  deleteDebitNote(debitNoteIds?: Array<Guid>): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: this.commonService.trimObjectSpace(JSON.stringify(debitNoteIds)),
    };
    return this.http.delete<any>(
      `${environment.apiVersionUrl}DebitNote/delete`,
      options
    );
  }

  copyDebitNote(debitNoteIds?: Array<Guid>): Observable<any> {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.put<any>(
      `${environment.apiVersionUrl}DebitNote/copyDebitNote`,
      this.commonService.trimObjectSpace(JSON.stringify(debitNoteIds)),
      headers
    );
  }

  archiveAndRestoreDebitNote(
    debitNoteIds?: Array<Guid>,
    isArchive?: boolean
  ): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.patch<any>(
      `${environment.apiVersionUrl}DebitNote/archive/${isArchive}`,
      this.commonService.trimObjectSpace(JSON.stringify(debitNoteIds)),
      options
    );
  }
}
